import { Progress, ProgressProps } from 'antd';
import React from 'react';

export type AppProgressProps = ProgressProps;

const AppProgress: React.FC<AppProgressProps> = props => {
  return <Progress {...props} />;
};

AppProgress.displayName = 'AppProgress';

export default AppProgress;
